import { Channel, Topic } from "../constants";
import { useCallback, useEffect } from "react";
import { MessageBrokerUtils } from "../utils";
import { RealityCheckActionCreators } from "../redux/action-creators";
import { useDispatch } from "react-redux";
import { Brand } from "../configurations";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../redux/selectors";
import { useFeature } from "./useFeature";
import { AppFeatures } from "../constants/featureFlags";

export const useSportSessionDetails = () => {
  const dispatch = useDispatch();
  const brandID = useSelector(UserContextSelectors.brandId);
  const getSessionTimeWithCustomActivationEnabled = useFeature(
    AppFeatures.GET_SESSION_TIME_WITH_CUSTOM_ACTIVATION
  );

  const handleSportSessionDetails = useCallback(
    sportSessionDetails => {
      dispatch(
        RealityCheckActionCreators.setSportSessionDetails(sportSessionDetails)
      );
    },
    [dispatch, brandID, getSessionTimeWithCustomActivationEnabled]
  );

  useEffect(() => {
    const handleSportSessionDetailsSubscription = MessageBrokerUtils.subscribe({
      channel: Channel.SESSION,
      topic: Topic.sportSessionDetails,
      callback: handleSportSessionDetails
    });

    return () => {
      handleSportSessionDetailsSubscription?.unsubscribe();
    };
  }, [handleSportSessionDetails]);
};
